import { gql } from '@apollo/client';

const usersFields = `
    user_ID
    archiver_ID
    arm_length_left
    arm_length_right
    corresponding_hole_house
    corresponding_hole_infra
    corresponding_hole_subscap
    corresponding_hole_supra
    corresponding_hole_teres
    creator_ID
    customer_ID
    date_archived
    date_birth
    date_created
    date_updated
    dominant_side
    email
    first_name
    forearm_length_left
    forearm_length_right
    gender
    height_feet
    height_inches
    last_name
    paddle_width
    password
    phone_number
    player_number
    player_position
    rookie_season
    school_year
    seat_height
    shoulder_bolster_height
    sport
    updater_ID
    user_name
    user_type_ID
    weight
`;

const usersQRCodesFields = `
    user_QR_code_ID,
    user_ID,
    QR_code,
    QR_code_parsed,
    exercise_date,
    start_time,
    end_time,
    L1_rep_supra,
    L2_rep_supra,
    L3_rep_supra,
    L4_rep_supra,
    L5_rep_supra,
    L1_weight_supra,
    L2_weight_supra,
    L3_weight_supra,
    L4_weight_supra,
    L5_weight_supra,
    R1_rep_supra,
    R2_rep_supra,
    R3_rep_supra,
    R4_rep_supra,
    R5_rep_supra,
    R1_weight_supra,
    R2_weight_supra,
    R3_weight_supra,
    R4_weight_supra,
    R5_weight_supra,
    L1_rep_subscap,
    L2_rep_subscap,
    L3_rep_subscap,
    L4_rep_subscap,
    L5_rep_subscap,
    L1_weight_subscap,
    L2_weight_subscap,
    L3_weight_subscap,
    L4_weight_subscap,
    L5_weight_subscap,
    R1_rep_subscap,
    R2_rep_subscap,
    R3_rep_subscap,
    R4_rep_subscap,
    R5_rep_subscap,
    R1_weight_subscap,
    R2_weight_subscap,
    R3_weight_subscap,
    R4_weight_subscap,
    R5_weight_subscap,
    L1_rep_infra,
    L2_rep_infra,
    L3_rep_infra,
    L4_rep_infra,
    L5_rep_infra,
    L1_weight_infra,
    L2_weight_infra,
    L3_weight_infra,
    L4_weight_infra,
    L5_weight_infra,
    R1_rep_infra,
    R2_rep_infra,
    R3_rep_infra,
    R4_rep_infra,
    R5_rep_infra,
    R1_weight_infra,
    R2_weight_infra,
    R3_weight_infra,
    R4_weight_infra,
    R5_weight_infra,
    L1_rep_teres,
    L2_rep_teres,
    L3_rep_teres,
    L4_rep_teres,
    L5_rep_teres,
    L1_weight_teres,
    L2_weight_teres,
    L3_weight_teres,
    L4_weight_teres,
    L5_weight_teres,
    R1_rep_teres,
    R2_rep_teres,
    R3_rep_teres,
    R4_rep_teres,
    R5_rep_teres,
    R1_weight_teres,
    R2_weight_teres,
    R3_weight_teres,
    R4_weight_teres,
    R5_weight_teres,
    L1_rep_surfer,
    L2_rep_surfer,
    L3_rep_surfer,
    L4_rep_surfer,
    L5_rep_surfer,
    L1_weight_surfer,
    L2_weight_surfer,
    L3_weight_surfer,
    L4_weight_surfer,
    L5_weight_surfer,
    R1_rep_surfer,
    R2_rep_surfer,
    R3_rep_surfer,
    R4_rep_surfer,
    R5_rep_surfer,
    R1_weight_surfer,
    R2_weight_surfer,
    R3_weight_surfer,
    R4_weight_surfer,
    R5_weight_surfer,
    L_torque,
    L_torque_supra,
    L_torque_subscap,
    L_torque_infra,
    L_torque_teres,
    L_torque_surfer,
    R_torque,
    R_torque_supra,
    R_torque_subscap,
    R_torque_infra,
    R_torque_teres,
    R_torque_surfer,
    torque_total
`;

const usersPTCFields = `
	user_PTC_ID
	creator_ID
	user_ID
    date_created
    date_performed
    L_burn_house
    L_max_house
    R_burn_house
    R_max_house
    L_burn_infra
    L_max_infra
    R_burn_infra
    R_max_infra
    L_burn_subscap
    L_max_subscap
    R_burn_subscap
    R_max_subscap
    L_burn_supra
    L_max_supra
    R_burn_supra
    R_max_supra
    L_burn_teres
    L_max_teres
    R_burn_teres
    R_max_teres
`;
export const GetUsers = gql`
    query GetUsers($archiver_ID: Int, $customer_ID: Int, $user_type_ID: Int) {
        users(archiver_ID: $archiver_ID, customer_ID: $customer_ID, user_type_ID: $user_type_ID) {
            ${usersFields}
            date_last_benchmark
            date_last_workout
        }
    }
`;
export const GetCustomers = gql`
    query GetCustomers($athletic: Int, $medical: Int) {
        customers(athletic: $athletic, medical: $medical) {
            customer_ID
            customer_name
            coach_code
            player_code
            company_logo_label
            level
            athletic
            medical
        }
    }
`;
export const GetUser = gql`
    query GetUser($user_ID: ID) {
        user (user_ID: $user_ID) {
            ${usersFields}
        }
    }
`;
export const GetUsersQRCodes = gql`
    query GetUsersQRCodes($user_ID: ID) {
        usersQRCodes (user_ID: $user_ID) {
            ${usersQRCodesFields}
        }
    }
`;
export const GetUsersQRCode = gql`
    query GetUsersQRCode($user_QR_code_ID: ID) {
        usersQRCode (user_QR_code_ID: $user_QR_code_ID) {
            ${usersQRCodesFields}
        }
    }
`;
export const GetUsersPTCs = gql`
    query GetUsersPTCs($user_ID: ID) {
        usersPTCs (user_ID: $user_ID) {
            ${usersPTCFields}
        }
    }
`;
export const GetUsersPTC = gql`
    query GetUsersPTC($user_PTC_ID: ID) {
        usersPTC (user_PTC_ID: $user_PTC_ID) {
            ${usersPTCFields}
        }
    }
`;
export const SaveUser = gql`
	mutation userSave($input: UserInput) {
		userSave (input: $input) {
            User {
                ${usersFields}
            }
		}
	}
`;
export const SaveUserQRCode = gql`
	mutation usersQRCodeSave($input: UserQRCodeInput) {
		usersQRCodeSave (input: $input) {
            ${usersQRCodesFields}
		}
	}
`;

export const SaveUserPTC = gql`
	mutation usersPTCSave($input: UserPTCInput) {
		usersPTCSave (input: $input) {
            ${usersPTCFields}
		}
	}
`;
export const ParseUserQRCode = gql`
	mutation usersQRCodeParse($QR_code: String) {
		usersQRCodeParse (QR_code: $QR_code) {
            ${usersQRCodesFields}
		}
	}
`;

			// Response {
			// 	success
			// 	message
			// }



